import I18n from 'i18n-js';
import { bool, string } from 'prop-types';

import style from './Disclaimer.module.scss';

const Disclaimer = ({
  name,
  lootKey,
  currency: basicCurrency,
  formattedPrice,
  ticketPayment,
}) => {
  let translation;

  if (/lootpack_season/.test(lootKey)) {
    translation = 'season_ticket_conditions_impressum';
  }

  const currency = !ticketPayment
    ? basicCurrency
    : I18n.t(`loot_ticket${formattedPrice > 1 ? 's' : ''}`);

  return (
    <div className={style.disclaimer}>
      <p>
        {I18n.t(translation || 'PurchaseView_text_info', {
          lootName: name,
          price: formattedPrice,
          currency,
        })}
      </p>
      {!translation && (
        <p>{I18n.t('PurchaseView_label_external_goods_disclaimer')}</p>
      )}
    </div>
  );
};

Disclaimer.propTypes = {
  name: string,
  lootKey: string,
  currency: string,
  formattedPrice: string,
  ticketPayment: bool,
};

export default Disclaimer;
